import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Col, Divider, PageHeader, Row, Spin, Form as FormInitial, message, Select } from 'antd'
import axios from 'axios';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  DatePickerItem,
  ButtonItem,
  ErrorItem,
  SelectInsumosItem,
} from "../../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import VistaPrevia from '../VistaPrevia/VistaPrevia';
import AgregarMarbetes from '../../Marbetes/AgregarMarbetes/AgregarMarbetes';
import ElegirMarbetes from '../../Marbetes/ElegirMarbetes/ElegirMarbetes';
import AgregarLotes from '../../LotesCaducidades/AgregarLotes/AgregarLotes';
import ElegirLotes from '../../LotesCaducidades/ElegirLotes/ElegirLotes';

const { Option } = Select

class AgregarOrdenDeProduccion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    todasInsumos: [],
    objetoInsumos: null,
    modalVistaPrevia: false,
    modalVistaPreviaId: null,
    modalAgregarMarbetes: false,
    modalAgregarMarbetesMarbetes: [],
    modalElegirMarbetes: false,
    modalElegirMarbetesMarbetes: [],
    modalElegirMarbetesInsumoId: null,
    modalElegirMarbetesProyectoId: null,
    modalAgregarLotes: false,
    modalAgregarLotesLotes: null,
    modalAgregarLotesVehiculo: false,
    modalAgregarLotesInsumoId : null,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "produccion/agregarOrdenDeProduccion",
        {
          ...values,
          empresaId: this.props.empresaId,
          marbetes: this.state.modalAgregarMarbetesMarbetes,
          lotes: this.state.modalAgregarLotesLotes,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se agrego una orden de producción"
          );
          NotificacionPolizas(res.data.polizasId)
          NotificacionMovimientosInventario(res.data.movimientosIds)
          this.setState({
            modalVistaPrevia: true,
            modalVistaPreviaId: res.data.id,
          });
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "No se pudo producir el insumo");
        } else {
          message.error("Hubo un error y el insumo no se produjo");
        }
      });
  }
  async onChangeInsumo(value, index, insumoEncontrado) {
    let proyecto = await this.formRef.current.getFieldValue("proyectoId");
    let arrayValue = await this.formRef.current.getFieldValue("insumosUtilizados");
    this.setState({ loading: true });
    const insumoId = arrayValue[index].insumoId;
    let insumo
    if (insumoEncontrado) {
      insumo = insumoEncontrado;
      const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
      if (!yaExiste) {
        await this.setState(prev => ({
          todasInsumos: [...prev.todasInsumos, insumo]
        }));
      }
    } else {
      insumo = this.state.todasInsumos.find(
        (valueInsumos) => valueInsumos._id === insumoId
      );
    }
    this.setState({ loading: false });
    if (!insumo) return
    await axios
      .post(
        "inventarios/inventarioInsumoProyecto",
        {
          proyectoId: proyecto,
          insumoId: insumoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        arrayValue[index].cantidadProyecto = res.data.cantidad;
      });
    this.formRef.current.setFieldsValue({
      insumosUtilizados: arrayValue,
    });
  }
  cerrarVistaPrevia() {
    this.setState({
      modalVistaPrevia: false,
      modalVistaPreviaId: null,
    });
    this.formRef.current.resetFields();
    this.atras();
  }
  abrirAgregarMarbetes(marbetes) {
    this.setState({
      modalAgregarMarbetes: true,
      modalAgregarMarbetesMarbetes: marbetes
    })
  }

  cerrarAgregarMarbetes(value) {
    this.setState({
      modalAgregarMarbetes: false,
      modalAgregarMarbetesMarbetes: value
    })
  }

  abrirElegirMarbetes(value, marbetes, insumoId) {
    const proyectoId = this.formRef.current.getFieldValue('proyectoId')
    this.setState({
      modalElegirMarbetes: true,
      modalElegirMarbetesIndex: value,
      modalElegirMarbetesMarbetes: marbetes || [],
      modalElegirMarbetesInsumoId: insumoId,
      modalElegirMarbetesProyectoId: proyectoId
    })
  }

  cerrarElegirMarbetes(value) {
    const insumosUtilizados = this.formRef.current.getFieldValue('insumosUtilizados')
    insumosUtilizados[this.state.modalElegirMarbetesIndex].marbetes = value
    this.formRef.current.setFieldsValue({
      insumosUtilizados: insumosUtilizados
    })
    this.setState({
      modalElegirMarbetes: false,
      modalElegirMarbetesIndex: null,
      modalElegirMarbetesMarbetes: null,
      modalElegirMarbetesInsumoId: null,
      modalElegirMarbetesProyectoId: null
    })
  }

  async onChangeInsumoGenerar(value, insumoEncontrado) {
    this.setState({ loading: true });
    let insumo
    if (insumoEncontrado) {
      insumo = insumoEncontrado;
      const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
      if (!yaExiste) {
        await this.setState(prev => ({
          todasInsumos: [...prev.todasInsumos, insumo]
        }));
      }
    } else {
      insumo = this.state.todasInsumos.find(
        (valueInsumos) => valueInsumos._id === value
      );
    }
    this.setState({ loading: false });
  }

  abrirAgregarLotes(vehiculo, lotes,insumoId) {
    this.setState({
      modalAgregarLotes: true,
      modalAgregarLotesLotes: lotes,
      modalAgregarLotesVehiculo: vehiculo,
      modalAgregarLotesInsumoId : insumoId, 
    });
  }

  cerrarAgregarLotes(value) {
    this.setState({
      modalAgregarLotes: false,
      modalAgregarLotesLotes: value,
      modalAgregarLotesVehiculo: false,
      modalAgregarLotesInsumoId : null, 
    });
  }

  abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirLotes: true,
        modalElegirLotesIndex: value,
        modalElegirLotesLotes: lotes || [],
        modalElegirLotesInsumoId: insumoId,
        modalElegirLotesProyectoId: proyectoId,
        modalElegirLotesClienteId: clienteId,
        modalElegirLotesCantidad: cantidad
      })
    } else {
      message.warning('Elegir un proyecto para elegir lotes')
    }
  }
  cerrarElegirLotes(value) {
    const insumos = this.formRef.current.getFieldValue('insumosUtilizados')
    insumos[this.state.modalElegirLotesIndex].lotes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirLotes: false,
      modalElegirLotesIndex: null,
      modalElegirLotesLotes: null,
      modalElegirLotesInsumoId: null,
      modalElegirLotesProyectoId: null,
      modalElegirLotesClienteId: null,
      modalElegirLotesCantidad: null
    })
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Orden de Producción"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="agregarOrdenDeProduccion"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Producir
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >
              <Divider
                style={{ marginBottom: 10, marginTop: 5 }}
                children="Insumo a Producir"
              />
              <Row>
                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                  <FormItem label="Insumo a Generar" name="insumoGeneradoId" margin required>
                    <SelectInsumosItem
                      empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                      headersToken={this.props.headersToken}
                      sinBorde
                      autoFocus
                      dropdownMatchSelectWidth={600}
                      width="100%"
                      placeholder="Insumo a Generar"
                      tiposInsumos="inventariables"
                      onChange={(value, insumoEncontrado) => { this.onChangeInsumoGenerar(value, insumoEncontrado) }}
                    />
                  </FormItem>
                </Col>
                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                  <FormItem
                    label="Cantidad a Generar"
                    name="cantidadGenerada"
                    number
                    required
                    type='number'
                    initialValue={1}
                  >
                    <InputNumberItem />
                  </FormItem>
                </Col>
                <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                  <FormItem
                    noStyle
                    shouldUpdate
                  >
                    {({ getFieldValue }) => {
                      let insumoGeneradoId = getFieldValue("insumoGeneradoId");
                      let mostrarMarbetes = false
                      let mostrarLotes = false
                      let mostrarVehiculo = false
                      let insumo = null;
                      if (insumoGeneradoId) {
                        insumo = this.state.todasInsumos.find(
                          (valueInsumos) => valueInsumos._id === insumoGeneradoId
                        );
                        mostrarMarbetes = insumo?.marbetes
                        mostrarLotes = insumo?.lotesCaducidades
                        mostrarVehiculo = insumo?.vehiculo
                      }
                      if (mostrarMarbetes) {
                        return (
                          <ButtonItem
                            type="primary"
                            size='small'
                            block
                            onClick={() => {
                              this.abrirAgregarMarbetes(this.state.modalAgregarMarbetesMarbetes)
                            }}
                          >
                            Marbetes
                          </ButtonItem>
                        )
                      }
                      if (mostrarLotes) {
                        return (
                          <ButtonItem
                            type="primary"
                            size='small'
                            block
                            onClick={() => {
                              const insumoId = insumo?._id
                              this.abrirAgregarLotes(mostrarVehiculo, this.state.modalAgregarLotesLotes,insumoId)
                            }}
                          >
                            {this.props.taxidermia ? 'Animales' : 'Lotes'}
                          </ButtonItem>
                        )
                      }
                    }}
                  </FormItem>
                </Col>
              </Row>
              <Divider
                style={{ marginBottom: 10, marginTop: 5 }}
                children="Proyecto"
              />
              <Row>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      const insumosUtilizados = getFieldValue('insumosUtilizados')
                      const disabled = insumosUtilizados?.length > 0
                      return (
                        <FormItem label="Proyecto" name="proyectoId" margin required>
                          <SelectItem placeholder="Proyecto" disabled={disabled}>
                            {this.state.objetoProyectos}
                          </SelectItem>
                        </FormItem>
                      )
                    }}
                  </FormItem>
                </Col>
                <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                  <FormItem
                    label="Fecha de Produccion"
                    name="fechaProduccion"
                    required
                    margin
                    initialValue={moment()}
                  >
                    <DatePickerItem
                      placeholder="Fecha de Produccion"
                      allowClear={false}
                    />
                  </FormItem>
                </Col>
              </Row>
              <Divider
                style={{ marginBottom: 10, marginTop: 5 }}
                children="Insumos a Utilizar"
              />
              <FormInitial.List name="insumosUtilizados">
                {(fields, { add, remove }) => (
                  <>
                    <div style={{ overflowX: 'auto' }}>
                      <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                        {fields.length > 0 ? (
                          <thead>
                            <tr>
                              <th className="th-border" style={{ width: '50%' }}>Insumo</th>
                              <th className="th-border" style={{ width: '19%' }}>Cantidad Proyecto</th>
                              <th className="th-border" style={{ width: '19%' }}>Cantidad</th>
                              <th className="th-border" style={{ width: '10%' }}>Accion</th>
                              <th className="th-border-sin-right" style={{ width: '2%' }}></th>
                            </tr>
                          </thead>
                        ) : null}
                        {fields.map(
                          ({ key, name, fieldKey, ...restField }, arrayKey) => (
                            <tbody>
                              <tr>
                                <td className="td-border">
                                  <FormItem
                                    {...restField}
                                    name={[name, "insumoId"]}
                                    fieldKey={[arrayKey, "insumoId"]}
                                    required
                                    noStyle
                                  >
                                    <SelectInsumosItem
                                      empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                      headersToken={this.props.headersToken}
                                      sinBorde
                                      autoFocus
                                      dropdownMatchSelectWidth={600}
                                      width="100%"
                                      placeholder="Insumo"
                                      tiposInsumos="inventariables"
                                      onChange={(value, insumoEncontrado) =>
                                        this.onChangeInsumo(
                                          value,
                                          arrayKey,
                                          insumoEncontrado
                                        )
                                      }
                                    />
                                  </FormItem>
                                </td>
                                <td className="td-border">
                                  <FormItem
                                    {...restField}
                                    name={[name, "cantidadProyecto"]}
                                    fieldKey={[arrayKey, "cantidadProyecto"]}
                                    number
                                    noStyle
                                    required
                                    initialValue={undefined}
                                  >
                                    <InputNumberItem sinBorde disabled />
                                  </FormItem>
                                </td>
                                <td className="td-border">
                                  <FormItem
                                    noStyle
                                    shouldUpdate={(prev, curr) =>
                                      prev.insumosUtilizados[arrayKey]?.cantidadProyecto !==
                                      curr.insumosUtilizados[arrayKey]?.cantidadProyecto
                                    }
                                  >
                                    {({ getFieldValue }) => {
                                      const insumosUtilizados = getFieldValue("insumosUtilizados");
                                      if (!insumosUtilizados[arrayKey]) return
                                      const cantidadProyecto =
                                        insumosUtilizados[arrayKey].cantidadProyecto;
                                      let max = cantidadProyecto;
                                      return (
                                        <FormItem
                                          {...restField}
                                          name={[name, "cantidad"]}
                                          fieldKey={[arrayKey, "cantidad"]}
                                          number
                                          noStyle
                                          required
                                          max={max}
                                          type='number'
                                          initialValue={undefined}
                                        >
                                          <InputNumberItem sinBorde />
                                        </FormItem>
                                      );
                                    }}
                                  </FormItem>
                                </td>
                                <td className="td-border">
                                  <Row>
                                    <Col span={24}>
                                      <FormItem
                                        noStyle
                                        shouldUpdate
                                      >
                                        {({ getFieldValue }) => {
                                          let arrayValue = getFieldValue("insumosUtilizados");
                                          const proyectoId = getFieldValue("proyectoId");
                                          let mostrarMarbetes = false
                                          let mostrarLotes = false
                                          let insumoId
                                          if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                            const insumo = this.state.todasInsumos.find(
                                              (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                            );
                                            mostrarMarbetes = insumo?.marbetes
                                            mostrarLotes = insumo?.lotesCaducidades
                                            insumoId = insumo?._id
                                          }
                                          if (mostrarMarbetes) {
                                            return (
                                              <ButtonItem
                                                type="primary"
                                                size='small'
                                                block
                                                onClick={() => {
                                                  this.abrirElegirMarbetes(arrayKey, arrayValue[arrayKey].marbetes, insumoId)
                                                }}
                                              >
                                                Marbetes
                                              </ButtonItem>
                                            )
                                          } else if (mostrarLotes) {
                                            return (
                                              <ButtonItem
                                                type="primary"
                                                size='small'
                                                style={{ width: '80%', marginLeft: '10%' }}
                                                block
                                                onClick={() => {
                                                  this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].cantidad)
                                                }}
                                              >
                                                {this.props.taxidermia ? "Animales" : "Lotes"}
                                              </ButtonItem>
                                            )
                                          }
                                        }}
                                      </FormItem>
                                    </Col>
                                  </Row>
                                </td>
                                <td>
                                  <MinusCircleOutlined
                                    onClick={() => remove(name)}
                                    style={{
                                      alignSelf: "center",
                                      justifySelf: "center",
                                    }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          )
                        )}
                      </table>
                    </div>
                    <FormItem
                      noStyle
                      shouldUpdate={(prev, curr) =>
                        prev.proyectoId !== curr.proyectoId
                      }
                    >
                      {({ getFieldValue }) => {
                        const proyecto = getFieldValue("proyectoId");
                        return (
                          <FormItem noStyle>
                            <ButtonItem
                              style={{ marginTop: 10, marginBottom: 10 }}
                              type="dashed"
                              onClick={
                                proyecto
                                  ? () => add()
                                  : () =>
                                    message.info(
                                      "Agregue el proyecto primero"
                                    )
                              }
                              block
                              icon={<PlusOutlined />}
                            >
                              Agregar Campo
                            </ButtonItem>
                          </FormItem>
                        );
                      }}
                    </FormItem>
                  </>
                )}
              </FormInitial.List>
            </Form>
          </Spin>
        </div>
        <VistaPrevia
          visible={this.state.modalVistaPrevia}
          id={this.state.modalVistaPreviaId}
          cerrarVistaPrevia={this.cerrarVistaPrevia.bind(this)}
        />
        <AgregarMarbetes
          visible={this.state.modalAgregarMarbetes}
          cerrarAgregarMarbetes={this.cerrarAgregarMarbetes.bind(this)}
          marbetes={this.state.modalAgregarMarbetesMarbetes}
        />
        <ElegirMarbetes
          visible={this.state.modalElegirMarbetes}
          cerrarElegirMarbetes={this.cerrarElegirMarbetes.bind(this)}
          marbetes={this.state.modalElegirMarbetesMarbetes}
          insumoId={this.state.modalElegirMarbetesInsumoId}
          proyectoId={this.state.modalElegirMarbetesProyectoId}
        />
        <AgregarLotes
          visible={this.state.modalAgregarLotes}
          cerrarAgregarLotes={this.cerrarAgregarLotes.bind(this)}
          lotes={this.state.modalAgregarLotesLotes}
          vehiculo={this.state.modalAgregarLotesVehiculo}
          insumoId = { this.state.modalAgregarLotesInsumoId}
        />
        <ElegirLotes
          visible={this.state.modalElegirLotes}
          cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
          lotes={this.state.modalElegirLotesLotes}
          insumoId={this.state.modalElegirLotesInsumoId}
          proyectoId={this.state.modalElegirLotesProyectoId}
          clienteId={this.state.modalElegirLotesClienteId}
          cantidad={this.state.modalElegirLotesCantidad}
        />
      </>
    )
  }

}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarOrdenDeProduccion);